
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./adapters/application.js"
import * as amdModule1 from "./adapters/assessments/assessment.js"
import * as amdModule2 from "./adapters/assessments/base.js"
import * as amdModule3 from "./adapters/assessments/category.js"
import * as amdModule4 from "./adapters/assessments/grade-schedule.js"
import * as amdModule5 from "./adapters/assessments/module.js"
import * as amdModule6 from "./adapters/auth/base.js"
import * as amdModule7 from "./adapters/auth/status.js"
import * as amdModule8 from "./adapters/client.js"
import * as amdModule9 from "./adapters/cron/base.js"
import * as amdModule10 from "./adapters/cron/log.js"
import * as amdModule11 from "./adapters/cron/process-monitor.js"
import * as amdModule12 from "./adapters/cron/task.js"
import * as amdModule13 from "./adapters/enrolments/base.js"
import * as amdModule14 from "./adapters/enrolments/credential.js"
import * as amdModule15 from "./adapters/enrolments/enrolment.js"
import * as amdModule16 from "./adapters/enrolments/identifier.js"
import * as amdModule17 from "./adapters/enrolments/log.js"
import * as amdModule18 from "./adapters/enrolments/schema.js"
import * as amdModule19 from "./adapters/enrolments/unenrolment.js"
import * as amdModule20 from "./adapters/goals/base.js"
import * as amdModule21 from "./adapters/goals/category.js"
import * as amdModule22 from "./adapters/goals/goal.js"
import * as amdModule23 from "./adapters/goals/subcategory.js"
import * as amdModule24 from "./adapters/goals/subject.js"
import * as amdModule25 from "./adapters/group.js"
import * as amdModule26 from "./adapters/media.js"
import * as amdModule27 from "./adapters/milestones/base.js"
import * as amdModule28 from "./adapters/milestones/expectation.js"
import * as amdModule29 from "./adapters/milestones/level.js"
import * as amdModule30 from "./adapters/milestones/milestone-set.js"
import * as amdModule31 from "./adapters/milestones/milestone.js"
import * as amdModule32 from "./adapters/milestones/set.js"
import * as amdModule33 from "./adapters/people-schema/base.js"
import * as amdModule34 from "./adapters/people-schema/field.js"
import * as amdModule35 from "./adapters/people-schema/group.js"
import * as amdModule36 from "./adapters/people-schema/set.js"
import * as amdModule37 from "./adapters/person.js"
import * as amdModule38 from "./adapters/posts/base.js"
import * as amdModule39 from "./adapters/posts/globalnotice.js"
import * as amdModule40 from "./adapters/posts/page.js"
import * as amdModule41 from "./adapters/posts/post-template.js"
import * as amdModule42 from "./adapters/posts/tag-category.js"
import * as amdModule43 from "./adapters/posts/tag.js"
import * as amdModule44 from "./adapters/reports/base.js"
import * as amdModule45 from "./adapters/reports/rubric-criteria.js"
import * as amdModule46 from "./adapters/reports/rubric-element.js"
import * as amdModule47 from "./adapters/reports/rubric-family.js"
import * as amdModule48 from "./adapters/reports/rubric.js"
import * as amdModule49 from "./adapters/school-options/field.js"
import * as amdModule50 from "./adapters/school-options/group.js"
import * as amdModule51 from "./adapters/school-options/heading.js"
import * as amdModule52 from "./adapters/school-options/set.js"
import * as amdModule53 from "./adapters/school.js"
import * as amdModule54 from "./adapters/schools/base.js"
import * as amdModule55 from "./adapters/schools/group.js"
import * as amdModule56 from "./adapters/schools/usage-set.js"
import * as amdModule57 from "./adapters/sif/au/base.js"
import * as amdModule58 from "./adapters/sif/au/zone.js"
import * as amdModule59 from "./adapters/timetable/base.js"
import * as amdModule60 from "./adapters/timetable/period.js"
import * as amdModule61 from "./adapters/timetable/structure.js"
import * as amdModule62 from "./adapters/user.js"
import * as amdModule63 from "./adapters/wonde/base.js"
import * as amdModule64 from "./adapters/wonde/connection.js"
import * as amdModule65 from "./adapters/wonde/school.js"
import * as amdModule66 from "./config/environment.js"
import * as amdModule67 from "./deprecation-workflow.js"
import * as amdModule68 from "./enums/auth-sync-status.ts"
import * as amdModule69 from "./enums/auth-sync-type.ts"
import * as amdModule70 from "./enums/enrolment-log-resource.ts"
import * as amdModule71 from "./enums/enrolment-nz-service.ts"
import * as amdModule72 from "./enums/log-level.ts"
import * as amdModule73 from "./enums/media-type.ts"
import * as amdModule74 from "./enums/page-type.ts"
import * as amdModule75 from "./enums/sif-authentication-method.ts"
import * as amdModule76 from "./enums/sif-country.ts"
import * as amdModule77 from "./enums/sif-encoding.ts"
import * as amdModule78 from "./enums/sif-matrix-param-location.ts"
import * as amdModule79 from "./mixins/age.js"
import * as amdModule80 from "./mixins/edit-assessment.js"
import * as amdModule81 from "./models/assessments/assessment.ts"
import * as amdModule82 from "./models/assessments/category.ts"
import * as amdModule83 from "./models/assessments/grade-schedule.ts"
import * as amdModule84 from "./models/assessments/module.ts"
import * as amdModule85 from "./models/auth/status-sync-error.ts"
import * as amdModule86 from "./models/auth/status.ts"
import * as amdModule87 from "./models/client.ts"
import * as amdModule88 from "./models/cron/log.ts"
import * as amdModule89 from "./models/cron/task.ts"
import * as amdModule90 from "./models/enrolments/credential-nz.ts"
import * as amdModule91 from "./models/enrolments/credential.ts"
import * as amdModule92 from "./models/enrolments/enrolment.ts"
import * as amdModule93 from "./models/enrolments/identifier.ts"
import * as amdModule94 from "./models/enrolments/log.ts"
import * as amdModule95 from "./models/enrolments/schema.ts"
import * as amdModule96 from "./models/enrolments/unenrolment.ts"
import * as amdModule97 from "./models/goals/category.ts"
import * as amdModule98 from "./models/goals/goal.ts"
import * as amdModule99 from "./models/goals/state.ts"
import * as amdModule100 from "./models/goals/subcategory.ts"
import * as amdModule101 from "./models/goals/subject.ts"
import * as amdModule102 from "./models/group.ts"
import * as amdModule103 from "./models/media.ts"
import * as amdModule104 from "./models/milestones/expectation.ts"
import * as amdModule105 from "./models/milestones/level.ts"
import * as amdModule106 from "./models/milestones/milestone-set.ts"
import * as amdModule107 from "./models/milestones/milestone.ts"
import * as amdModule108 from "./models/milestones/set.ts"
import * as amdModule109 from "./models/people-schema/field.ts"
import * as amdModule110 from "./models/people-schema/group.ts"
import * as amdModule111 from "./models/people-schema/set.ts"
import * as amdModule112 from "./models/person.ts"
import * as amdModule113 from "./models/posts/globalnotice.ts"
import * as amdModule114 from "./models/posts/page-set.ts"
import * as amdModule115 from "./models/posts/page.ts"
import * as amdModule116 from "./models/posts/post-template.ts"
import * as amdModule117 from "./models/posts/tag-category.ts"
import * as amdModule118 from "./models/posts/tag.ts"
import * as amdModule119 from "./models/school-options/field.ts"
import * as amdModule120 from "./models/school-options/group.ts"
import * as amdModule121 from "./models/school-options/heading.ts"
import * as amdModule122 from "./models/school-options/set.ts"
import * as amdModule123 from "./models/school.ts"
import * as amdModule124 from "./models/schools/group.ts"
import * as amdModule125 from "./models/schools/usage-set.ts"
import * as amdModule126 from "./models/user.ts"
import * as amdModule127 from "./router.js"
import * as amdModule128 from "./serializers/application.js"
import * as amdModule129 from "./serializers/assessments/assessment.js"
import * as amdModule130 from "./serializers/assessments/base.js"
import * as amdModule131 from "./serializers/assessments/category.js"
import * as amdModule132 from "./serializers/assessments/grade-schedule.js"
import * as amdModule133 from "./serializers/assessments/module.js"
import * as amdModule134 from "./serializers/auth/base.js"
import * as amdModule135 from "./serializers/auth/status.js"
import * as amdModule136 from "./serializers/cron/log.js"
import * as amdModule137 from "./serializers/cron/task.js"
import * as amdModule138 from "./serializers/enrolments/base.js"
import * as amdModule139 from "./serializers/enrolments/credential.js"
import * as amdModule140 from "./serializers/enrolments/enrolment.js"
import * as amdModule141 from "./serializers/enrolments/identifier.js"
import * as amdModule142 from "./serializers/enrolments/log.js"
import * as amdModule143 from "./serializers/enrolments/schema.js"
import * as amdModule144 from "./serializers/enrolments/unenrolment.js"
import * as amdModule145 from "./serializers/goals/base.js"
import * as amdModule146 from "./serializers/goals/category.js"
import * as amdModule147 from "./serializers/goals/goal.js"
import * as amdModule148 from "./serializers/goals/subcategory.js"
import * as amdModule149 from "./serializers/goals/subject.js"
import * as amdModule150 from "./serializers/group.js"
import * as amdModule151 from "./serializers/milestones/base.js"
import * as amdModule152 from "./serializers/milestones/expectation.js"
import * as amdModule153 from "./serializers/milestones/level.js"
import * as amdModule154 from "./serializers/milestones/milestone-set.js"
import * as amdModule155 from "./serializers/milestones/milestone.js"
import * as amdModule156 from "./serializers/milestones/set.js"
import * as amdModule157 from "./serializers/people-schema/base.js"
import * as amdModule158 from "./serializers/people-schema/field.js"
import * as amdModule159 from "./serializers/people-schema/group.js"
import * as amdModule160 from "./serializers/people-schema/set.js"
import * as amdModule161 from "./serializers/posts/base.js"
import * as amdModule162 from "./serializers/posts/page.js"
import * as amdModule163 from "./serializers/posts/post-template.js"
import * as amdModule164 from "./serializers/posts/tag-category.js"
import * as amdModule165 from "./serializers/posts/tag.js"
import * as amdModule166 from "./serializers/reports/rubric-criteria.js"
import * as amdModule167 from "./serializers/school-options/field.js"
import * as amdModule168 from "./serializers/school-options/group.js"
import * as amdModule169 from "./serializers/school-options/heading.js"
import * as amdModule170 from "./serializers/school-options/set.js"
import * as amdModule171 from "./serializers/school.js"
import * as amdModule172 from "./serializers/schools/base.js"
import * as amdModule173 from "./serializers/schools/group.js"
import * as amdModule174 from "./serializers/schools/usage-set.js"
import * as amdModule175 from "./serializers/sif/au/base.js"
import * as amdModule176 from "./serializers/sif/au/zone.js"
import * as amdModule177 from "./serializers/user.js"
import * as amdModule178 from "./services/roles.js"
import * as amdModule179 from "./services/school-schema.js"
import * as amdModule180 from "./services/store.js"
import * as amdModule181 from "./transforms/array-string.js"
import * as amdModule182 from "./utils/api-error-detail.ts"
import * as amdModule183 from "./utils/destroy-record.js"
import * as amdModule184 from "./utils/filtering.js"
import * as amdModule185 from "./utils/strings.js"
import * as amdModule186 from "./initializers/viewport-config.js"
import * as amdModule187 from "./services/in-viewport.js"
import * as amdModule188 from "./services/-ensure-registered.js"
import * as amdModule189 from "./instance-initializers/ember-href-to.js"
import * as amdModule190 from "./services/constants.js"
import * as amdModule191 from "./services/paper-sidenav.js"
import * as amdModule192 from "./services/paper-theme.js"
import * as amdModule193 from "./services/paper-toaster.js"
import * as amdModule194 from "./services/sniffer.js"
import * as amdModule195 from "./utils/clamp.js"
import * as amdModule196 from "./transforms/array.js"
import * as amdModule197 from "./transforms/fragment-array.js"
import * as amdModule198 from "./transforms/fragment.js"
import * as amdModule199 from "./initializers/ember-data.js"
import * as amdModule200 from "./transforms/date.js"
import * as amdModule201 from "./transforms/number.js"
import * as amdModule202 from "./transforms/string.js"
import * as amdModule203 from "./transforms/boolean.js"
import * as amdModule204 from "./data-adapter.js"
import * as amdModule205 from "./adapters/base.js"
import * as amdModule206 from "./adapters/device.js"
import * as amdModule207 from "./adapters/policy.js"
import * as amdModule208 from "./initializers/fragment-array-iterable.js"
import * as amdModule209 from "./initializers/fragment-array-mutable.js"
import * as amdModule210 from "./initializers/oauth2.js"
import * as amdModule211 from "./initializers/query-params-helper.js"
import * as amdModule212 from "./instance-initializers/faro.js"
import * as amdModule213 from "./models/address.js"
import * as amdModule214 from "./models/assessments/grade.js"
import * as amdModule215 from "./models/assessments/gradeschedule-numeric.js"
import * as amdModule216 from "./models/assessments/gradeschedule-range.js"
import * as amdModule217 from "./models/assessments/gradeschedule-select.js"
import * as amdModule218 from "./models/assessments/gradeschedule-selectvalue.js"
import * as amdModule219 from "./models/attendance/nz-moe-day.js"
import * as amdModule220 from "./models/auth/qr-code.js"
import * as amdModule221 from "./models/autogroup-params.js"
import * as amdModule222 from "./models/bookings/allocation.js"
import * as amdModule223 from "./models/bookings/booking.js"
import * as amdModule224 from "./models/bookings/date.js"
import * as amdModule225 from "./models/bookings/event.js"
import * as amdModule226 from "./models/bookings/reservation.js"
import * as amdModule227 from "./models/bookings/session.js"
import * as amdModule228 from "./models/bookings/slot.js"
import * as amdModule229 from "./models/bookings/teacher-group-mapping.js"
import * as amdModule230 from "./models/cron/process-monitor-error.js"
import * as amdModule231 from "./models/cron/process-monitor.js"
import * as amdModule232 from "./models/cron/progress.js"
import * as amdModule233 from "./models/device.js"
import * as amdModule234 from "./models/dynamic-field/value-list-item.js"
import * as amdModule235 from "./models/dynamic-field/value.js"
import * as amdModule236 from "./models/dynamic-field/values.js"
import * as amdModule237 from "./models/enrolments/field.js"
import * as amdModule238 from "./models/enrolments/medical-condition.js"
import * as amdModule239 from "./models/enrolments/section.js"
import * as amdModule240 from "./models/events/cost-mapping-option.js"
import * as amdModule241 from "./models/events/cost-mapping.js"
import * as amdModule242 from "./models/events/event-count.js"
import * as amdModule243 from "./models/events/event.js"
import * as amdModule244 from "./models/events/mitigation.js"
import * as amdModule245 from "./models/events/option-count.js"
import * as amdModule246 from "./models/events/option-limit.js"
import * as amdModule247 from "./models/events/permission-reply.js"
import * as amdModule248 from "./models/events/permission.js"
import * as amdModule249 from "./models/events/risk.js"
import * as amdModule250 from "./models/events/template.js"
import * as amdModule251 from "./models/events/value-limit.js"
import * as amdModule252 from "./models/finance/account.js"
import * as amdModule253 from "./models/finance/line-item.js"
import * as amdModule254 from "./models/goals/badge-assertion.js"
import * as amdModule255 from "./models/goals/badge-badge.js"
import * as amdModule256 from "./models/goals/badge-criteria.js"
import * as amdModule257 from "./models/goals/badge-profile.js"
import * as amdModule258 from "./models/goals/badge-recipient.js"
import * as amdModule259 from "./models/goals/badge-verification.js"
import * as amdModule260 from "./models/goals/badge.js"
import * as amdModule261 from "./models/groups/member.js"
import * as amdModule262 from "./models/media/image.js"
import * as amdModule263 from "./models/media/rendition.js"
import * as amdModule264 from "./models/media/video.js"
import * as amdModule265 from "./models/milestones/progression.js"
import * as amdModule266 from "./models/notifications/notification.js"
import * as amdModule267 from "./models/people-schema/field-option.js"
import * as amdModule268 from "./models/people/caregiver.js"
import * as amdModule269 from "./models/people/learner.js"
import * as amdModule270 from "./models/people/medical.js"
import * as amdModule271 from "./models/people/options.js"
import * as amdModule272 from "./models/people/policy-acceptance.js"
import * as amdModule273 from "./models/people/post-count-assessment.js"
import * as amdModule274 from "./models/people/post-count-base.js"
import * as amdModule275 from "./models/people/post-count-goal.js"
import * as amdModule276 from "./models/people/post-count-page.js"
import * as amdModule277 from "./models/people/post-counts.js"
import * as amdModule278 from "./models/people/staff.js"
import * as amdModule279 from "./models/policy.js"
import * as amdModule280 from "./models/posts/attendancenote.js"
import * as amdModule281 from "./models/posts/comment.js"
import * as amdModule282 from "./models/posts/feed-entry.js"
import * as amdModule283 from "./models/posts/member.js"
import * as amdModule284 from "./models/posts/post.js"
import * as amdModule285 from "./models/posts/reaction.js"
import * as amdModule286 from "./models/reports/report-feedback.js"
import * as amdModule287 from "./models/reports/report-judgement-wording.js"
import * as amdModule288 from "./models/reports/report-template-period.js"
import * as amdModule289 from "./models/reports/report-template-section.js"
import * as amdModule290 from "./models/reports/report-template.js"
import * as amdModule291 from "./models/reports/rubric-column.js"
import * as amdModule292 from "./models/reports/rubric-criteria.js"
import * as amdModule293 from "./models/reports/rubric-element.js"
import * as amdModule294 from "./models/reports/rubric-family.js"
import * as amdModule295 from "./models/reports/rubric-state.js"
import * as amdModule296 from "./models/reports/rubric.js"
import * as amdModule297 from "./models/reports/student-report-section-element.js"
import * as amdModule298 from "./models/reports/student-report-section.js"
import * as amdModule299 from "./models/reports/student-report.js"
import * as amdModule300 from "./models/schools/location.js"
import * as amdModule301 from "./models/sif/au/connection.js"
import * as amdModule302 from "./models/sif/au/zone.js"
import * as amdModule303 from "./models/snapshots/pdf-include.js"
import * as amdModule304 from "./models/snapshots/pdf.js"
import * as amdModule305 from "./models/snapshots/snapshot-set.js"
import * as amdModule306 from "./models/snapshots/snapshot.js"
import * as amdModule307 from "./models/surveys/response.js"
import * as amdModule308 from "./models/surveys/survey.js"
import * as amdModule309 from "./models/term.js"
import * as amdModule310 from "./models/timeframe.js"
import * as amdModule311 from "./models/timetable/day.js"
import * as amdModule312 from "./models/timetable/period.js"
import * as amdModule313 from "./models/timetable/structure.js"
import * as amdModule314 from "./models/wonde/address.js"
import * as amdModule315 from "./models/wonde/connection.js"
import * as amdModule316 from "./models/wonde/school.js"
import * as amdModule317 from "./serializers/address.js"
import * as amdModule318 from "./serializers/auth/qr-code.js"
import * as amdModule319 from "./serializers/bookings/allocation.js"
import * as amdModule320 from "./serializers/bookings/base.js"
import * as amdModule321 from "./serializers/bookings/booking.js"
import * as amdModule322 from "./serializers/bookings/event.js"
import * as amdModule323 from "./serializers/bookings/slot.js"
import * as amdModule324 from "./serializers/cron/process-monitor.js"
import * as amdModule325 from "./serializers/dynamic-field/value.js"
import * as amdModule326 from "./serializers/events/base.js"
import * as amdModule327 from "./serializers/events/cost-mapping-option.js"
import * as amdModule328 from "./serializers/events/cost-mapping.js"
import * as amdModule329 from "./serializers/events/event-count.js"
import * as amdModule330 from "./serializers/events/event.js"
import * as amdModule331 from "./serializers/events/mitigation.js"
import * as amdModule332 from "./serializers/events/permission-reply.js"
import * as amdModule333 from "./serializers/events/permission.js"
import * as amdModule334 from "./serializers/events/risk.js"
import * as amdModule335 from "./serializers/events/template.js"
import * as amdModule336 from "./serializers/goals/badge.js"
import * as amdModule337 from "./serializers/goals/state.js"
import * as amdModule338 from "./serializers/media.js"
import * as amdModule339 from "./serializers/milestones/progression.js"
import * as amdModule340 from "./serializers/person.js"
import * as amdModule341 from "./serializers/posts/attendancenote.js"
import * as amdModule342 from "./serializers/posts/comment.js"
import * as amdModule343 from "./serializers/posts/feed-entry.js"
import * as amdModule344 from "./serializers/posts/globalnotice.js"
import * as amdModule345 from "./serializers/posts/page-set.js"
import * as amdModule346 from "./serializers/posts/post.js"
import * as amdModule347 from "./serializers/posts/reaction.js"
import * as amdModule348 from "./serializers/reports/base.js"
import * as amdModule349 from "./serializers/reports/report-feedback.js"
import * as amdModule350 from "./serializers/reports/report-template-section.js"
import * as amdModule351 from "./serializers/reports/report-template.js"
import * as amdModule352 from "./serializers/reports/rubric-element.js"
import * as amdModule353 from "./serializers/reports/rubric-family.js"
import * as amdModule354 from "./serializers/reports/rubric-state.js"
import * as amdModule355 from "./serializers/reports/rubric.js"
import * as amdModule356 from "./serializers/reports/student-report-section.js"
import * as amdModule357 from "./serializers/reports/student-report.js"
import * as amdModule358 from "./serializers/sif/au/connection.js"
import * as amdModule359 from "./serializers/surveys/base.js"
import * as amdModule360 from "./serializers/surveys/response.js"
import * as amdModule361 from "./serializers/surveys/survey.js"
import * as amdModule362 from "./serializers/timetable/base.js"
import * as amdModule363 from "./serializers/timetable/period.js"
import * as amdModule364 from "./serializers/timetable/structure.js"
import * as amdModule365 from "./serializers/wonde/connection.js"
import * as amdModule366 from "./serializers/wonde/school.js"
import * as amdModule367 from "./services/colours.js"
import * as amdModule368 from "./services/dates.js"
import * as amdModule369 from "./services/environment.js"
import * as amdModule370 from "./services/faro.js"
import * as amdModule371 from "./services/fetch.js"
import * as amdModule372 from "./services/field-options.js"
import * as amdModule373 from "./services/google-drive.js"
import * as amdModule374 from "./services/group-years.js"
import * as amdModule375 from "./services/hero-api-auth.js"
import * as amdModule376 from "./services/hero-api-bookings-allocations.js"
import * as amdModule377 from "./services/hero-api-bookings.js"
import * as amdModule378 from "./services/hero-api-comments.js"
import * as amdModule379 from "./services/hero-api-goals.js"
import * as amdModule380 from "./services/hero-api-people.js"
import * as amdModule381 from "./services/hero-api.js"
import * as amdModule382 from "./services/logging.js"
import * as amdModule383 from "./services/media.js"
import * as amdModule384 from "./services/notifications.js"
import * as amdModule385 from "./services/options.js"
import * as amdModule386 from "./services/permissions.js"
import * as amdModule387 from "./services/person-options.js"
import * as amdModule388 from "./services/policy-acceptance.js"
import * as amdModule389 from "./services/print.js"
import * as amdModule390 from "./services/push-notifications.js"
import * as amdModule391 from "./services/session.js"
import * as amdModule392 from "./services/strings.js"
import * as amdModule393 from "./services/tax.js"
import * as amdModule394 from "./services/terms.js"
import * as amdModule395 from "./services/toaster.js"
import * as amdModule396 from "./services/uppy.js"
import * as amdModule397 from "./transforms/json.js"
import * as amdModule398 from "./utils/auditing.js"
import * as amdModule399 from "./utils/chunk.js"
import * as amdModule400 from "./utils/colour.js"
import * as amdModule401 from "./utils/d3-tip.js"
import * as amdModule402 from "./utils/dynamic-field-types.js"
import * as amdModule403 from "./utils/fields.js"
import * as amdModule404 from "./utils/grades.js"
import * as amdModule405 from "./utils/long-tasks.js"
import * as amdModule406 from "./utils/map-with-concurrency.js"
import * as amdModule407 from "./utils/oauth2.js"
import * as amdModule408 from "./utils/options.js"
import * as amdModule409 from "./utils/platform.js"
import * as amdModule410 from "./utils/post-templates.js"
import * as amdModule411 from "./utils/progressions.js"
import * as amdModule412 from "./utils/pronouns.js"
import * as amdModule413 from "./utils/reports.js"
import * as amdModule414 from "./utils/school-date.js"
import * as amdModule415 from "./utils/snapshots.js"
import * as amdModule416 from "./utils/stationery.js"
import * as amdModule417 from "./utils/table.js"
import * as amdModule418 from "./utils/tags.js"
import * as amdModule419 from "./utils/tinymce.js"
import * as amdModule420 from "./utils/topic-steps.js"
import * as amdModule421 from "./services/page-title.js"
import * as amdModule422 from "./services/drag-sort.js"
import * as amdModule423 from "./templates/application.hbs"
import * as amdModule424 from "./controllers/application.js"
import * as amdModule425 from "./routes/application.js"
import * as amdModule426 from "./templates/assessments.hbs"
import * as amdModule427 from "./controllers/assessments.js"
import * as amdModule428 from "./routes/assessments.js"
import * as amdModule429 from "./templates/assessments/assessment.hbs"
import * as amdModule430 from "./controllers/assessments/assessment.js"
import * as amdModule431 from "./routes/assessments/assessment.js"
import * as amdModule432 from "./templates/assessments/grade-schedules.hbs"
import * as amdModule433 from "./controllers/assessments/grade-schedules.js"
import * as amdModule434 from "./routes/assessments/grade-schedules.js"
import * as amdModule435 from "./templates/assessments/index.hbs"
import * as amdModule436 from "./controllers/assessments/index.js"
import * as amdModule437 from "./routes/assessments/index.js"
import * as amdModule438 from "./templates/auth/clients.hbs"
import * as amdModule439 from "./controllers/auth/clients.js"
import * as amdModule440 from "./routes/auth/clients.js"
import * as amdModule441 from "./templates/auth/fusionauth.hbs"
import * as amdModule442 from "./controllers/auth/fusionauth.js"
import * as amdModule443 from "./templates/autogroups.hbs"
import * as amdModule444 from "./controllers/autogroups.js"
import * as amdModule445 from "./routes/autogroups.js"
import * as amdModule446 from "./templates/contacts/search.hbs"
import * as amdModule447 from "./controllers/contacts/search.js"
import * as amdModule448 from "./routes/contacts/search.js"
import * as amdModule449 from "./templates/cron/index.hbs"
import * as amdModule450 from "./controllers/cron/index.js"
import * as amdModule451 from "./routes/cron/index.js"
import * as amdModule452 from "./templates/cron/task.hbs"
import * as amdModule453 from "./controllers/cron/task.js"
import * as amdModule454 from "./routes/cron/task.js"
import * as amdModule455 from "./templates/enrolment/schema/template.hbs"
import * as amdModule456 from "./controllers/enrolment/schema/template.js"
import * as amdModule457 from "./routes/enrolment/schema/template.js"
import * as amdModule458 from "./templates/enrolment/schema/templates.hbs"
import * as amdModule459 from "./controllers/enrolment/schema/templates.js"
import * as amdModule460 from "./routes/enrolment/schema/templates.js"
import * as amdModule461 from "./templates/error.hbs"
import * as amdModule462 from "./controllers/error.js"
import * as amdModule463 from "./templates/finance/nsw-sap/transaction-upload.hbs"
import * as amdModule464 from "./controllers/finance/nsw-sap/transaction-upload.js"
import * as amdModule465 from "./routes/finance/nsw-sap/transaction-upload.js"
import * as amdModule466 from "./templates/finance/nz-report.hbs"
import * as amdModule467 from "./controllers/finance/nz-report.js"
import * as amdModule468 from "./routes/finance/nz-report.js"
import * as amdModule469 from "./templates/finance/schema-update.hbs"
import * as amdModule470 from "./controllers/finance/schema-update.js"
import * as amdModule471 from "./routes/finance/schema-update.js"
import * as amdModule472 from "./templates/goals.hbs"
import * as amdModule473 from "./routes/goals.js"
import * as amdModule474 from "./templates/goals/index.hbs"
import * as amdModule475 from "./controllers/goals/index.js"
import * as amdModule476 from "./routes/goals/index.js"
import * as amdModule477 from "./templates/goals/plp.hbs"
import * as amdModule478 from "./controllers/goals/plp.js"
import * as amdModule479 from "./routes/goals/plp.js"
import * as amdModule480 from "./templates/goals/subject.hbs"
import * as amdModule481 from "./controllers/goals/subject.js"
import * as amdModule482 from "./routes/goals/subject.js"
import * as amdModule483 from "./templates/hero-notices.hbs"
import * as amdModule484 from "./routes/hero-notices.js"
import * as amdModule485 from "./templates/hero-notices/index.hbs"
import * as amdModule486 from "./controllers/hero-notices/index.js"
import * as amdModule487 from "./routes/hero-notices/index.js"
import * as amdModule488 from "./templates/hero-notices/notice.hbs"
import * as amdModule489 from "./controllers/hero-notices/notice.js"
import * as amdModule490 from "./routes/hero-notices/notice.js"
import * as amdModule491 from "./templates/home.hbs"
import * as amdModule492 from "./controllers/home.js"
import * as amdModule493 from "./routes/home.js"
import * as amdModule494 from "./controllers/index.js"
import * as amdModule495 from "./routes/index.js"
import * as amdModule496 from "./templates/logs/enrolments.hbs"
import * as amdModule497 from "./controllers/logs/enrolments.js"
import * as amdModule498 from "./routes/logs/enrolments.js"
import * as amdModule499 from "./templates/milestones/set.hbs"
import * as amdModule500 from "./controllers/milestones/set.js"
import * as amdModule501 from "./routes/milestones/set.js"
import * as amdModule502 from "./templates/milestones/sets.hbs"
import * as amdModule503 from "./controllers/milestones/sets.js"
import * as amdModule504 from "./routes/milestones/sets.js"
import * as amdModule505 from "./templates/my-profile.hbs"
import * as amdModule506 from "./controllers/my-profile.js"
import * as amdModule507 from "./routes/my-profile.js"
import * as amdModule508 from "./templates/page-templates.hbs"
import * as amdModule509 from "./controllers/page-templates.js"
import * as amdModule510 from "./routes/page-templates.js"
import * as amdModule511 from "./templates/people.hbs"
import * as amdModule512 from "./routes/people.js"
import * as amdModule513 from "./templates/people/schema/apply-templates.hbs"
import * as amdModule514 from "./controllers/people/schema/apply-templates.js"
import * as amdModule515 from "./routes/people/schema/apply-templates.js"
import * as amdModule516 from "./templates/people/schema/resequence-groups.hbs"
import * as amdModule517 from "./controllers/people/schema/resequence-groups.js"
import * as amdModule518 from "./routes/people/schema/resequence-groups.js"
import * as amdModule519 from "./templates/people/schema/template.hbs"
import * as amdModule520 from "./routes/people/schema/template.js"
import * as amdModule521 from "./templates/people/schema/template/group.hbs"
import * as amdModule522 from "./controllers/people/schema/template/group.js"
import * as amdModule523 from "./routes/people/schema/template/group.js"
import * as amdModule524 from "./templates/people/schema/template/groups.hbs"
import * as amdModule525 from "./controllers/people/schema/template/groups.js"
import * as amdModule526 from "./routes/people/schema/template/groups.js"
import * as amdModule527 from "./templates/people/schema/template/view.hbs"
import * as amdModule528 from "./controllers/people/schema/template/view.js"
import * as amdModule529 from "./routes/people/schema/template/view.js"
import * as amdModule530 from "./templates/people/schema/templates.hbs"
import * as amdModule531 from "./controllers/people/schema/templates.js"
import * as amdModule532 from "./routes/people/schema/templates.js"
import * as amdModule533 from "./templates/people/information.hbs"
import * as amdModule534 from "./routes/people/information.js"
import * as amdModule535 from "./templates/post-templates.hbs"
import * as amdModule536 from "./controllers/post-templates.js"
import * as amdModule537 from "./routes/post-templates.js"
import * as amdModule538 from "./templates/rubrics.hbs"
import * as amdModule539 from "./controllers/rubrics.js"
import * as amdModule540 from "./routes/rubrics.js"
import * as amdModule541 from "./templates/rubrics/index.hbs"
import * as amdModule542 from "./controllers/rubrics/index.js"
import * as amdModule543 from "./routes/rubrics/index.js"
import * as amdModule544 from "./templates/rubrics/rubric.hbs"
import * as amdModule545 from "./controllers/rubrics/rubric.js"
import * as amdModule546 from "./routes/rubrics/rubric.js"
import * as amdModule547 from "./templates/school-groups.hbs"
import * as amdModule548 from "./controllers/school-groups.js"
import * as amdModule549 from "./routes/school-groups.js"
import * as amdModule550 from "./templates/school-options/fields.hbs"
import * as amdModule551 from "./controllers/school-options/fields.js"
import * as amdModule552 from "./routes/school-options/fields.js"
import * as amdModule553 from "./templates/school-options/groups.hbs"
import * as amdModule554 from "./controllers/school-options/groups.js"
import * as amdModule555 from "./routes/school-options/groups.js"
import * as amdModule556 from "./templates/school-options/headings.hbs"
import * as amdModule557 from "./controllers/school-options/headings.js"
import * as amdModule558 from "./routes/school-options/headings.js"
import * as amdModule559 from "./templates/school-options/preview.hbs"
import * as amdModule560 from "./controllers/school-options/preview.js"
import * as amdModule561 from "./routes/school-options/preview.js"
import * as amdModule562 from "./templates/school-options/sets.hbs"
import * as amdModule563 from "./controllers/school-options/sets.js"
import * as amdModule564 from "./routes/school-options/sets.js"
import * as amdModule565 from "./templates/schools.hbs"
import * as amdModule566 from "./controllers/schools.js"
import * as amdModule567 from "./routes/schools.js"
import * as amdModule568 from "./templates/sif/zones.hbs"
import * as amdModule569 from "./controllers/sif/zones.js"
import * as amdModule570 from "./routes/sif/zones.js"
import * as amdModule571 from "./templates/tags.hbs"
import * as amdModule572 from "./controllers/tags.js"
import * as amdModule573 from "./routes/tags.js"
import * as amdModule574 from "./templates/tags/category.hbs"
import * as amdModule575 from "./controllers/tags/category.js"
import * as amdModule576 from "./routes/tags/category.js"
import * as amdModule577 from "./templates/tags/index.hbs"
import * as amdModule578 from "./controllers/tags/index.js"
import * as amdModule579 from "./routes/tags/index.js"
import * as amdModule580 from "./templates/usage-sets.hbs"
import * as amdModule581 from "./routes/usage-sets.js"
import * as amdModule582 from "./templates/usage-sets/index.hbs"
import * as amdModule583 from "./controllers/usage-sets/index.js"
import * as amdModule584 from "./routes/usage-sets/index.js"
import * as amdModule585 from "./templates/usage-sets/usage-set.hbs"
import * as amdModule586 from "./controllers/usage-sets/usage-set.js"
import * as amdModule587 from "./routes/usage-sets/usage-set.js"
import * as amdModule588 from "./templates/users.hbs"
import * as amdModule589 from "./controllers/users.js"
import * as amdModule590 from "./routes/users.js"
import * as amdModule591 from "./templates/wonde/connections.hbs"
import * as amdModule592 from "./controllers/wonde/connections.js"
import * as amdModule593 from "./routes/wonde/connections.js"
import * as amdModule594 from "./templates/access-denied.hbs"
import * as amdModule595 from "./templates/loading.hbs"
import * as amdModule596 from "./templates/logged-out.js"
import * as amdModule597 from "./controllers/logged-out.js"
import * as amdModule598 from "./routes/logged-out.js"
import * as amdModule599 from "./templates/login-failed.js"
import * as amdModule600 from "./controllers/login-failed.js"
import * as amdModule601 from "./routes/login-failed.js"
import * as amdModule602 from "./templates/school-switching.js"
import * as amdModule603 from "./controllers/school-switching.js"
import * as amdModule604 from "./routes/school-switching.js"
import * as amdModule605 from "./templates/callback.js"
import * as amdModule606 from "./routes/callback.js"
import * as amdModule607 from "./routes/login.js"
import * as amdModule608 from "./templates/logout.js"
import * as amdModule609 from "./routes/logout.js"
import * as amdModule610 from "./routes/springboard.js"
import * as amdModule611 from "./routes/startup.js"
import * as amdModule612 from "./templates/not-found.js"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"linced-admin/adapters/application": amdModule0,
"linced-admin/adapters/assessments/assessment": amdModule1,
"linced-admin/adapters/assessments/base": amdModule2,
"linced-admin/adapters/assessments/category": amdModule3,
"linced-admin/adapters/assessments/grade-schedule": amdModule4,
"linced-admin/adapters/assessments/module": amdModule5,
"linced-admin/adapters/auth/base": amdModule6,
"linced-admin/adapters/auth/status": amdModule7,
"linced-admin/adapters/client": amdModule8,
"linced-admin/adapters/cron/base": amdModule9,
"linced-admin/adapters/cron/log": amdModule10,
"linced-admin/adapters/cron/process-monitor": amdModule11,
"linced-admin/adapters/cron/task": amdModule12,
"linced-admin/adapters/enrolments/base": amdModule13,
"linced-admin/adapters/enrolments/credential": amdModule14,
"linced-admin/adapters/enrolments/enrolment": amdModule15,
"linced-admin/adapters/enrolments/identifier": amdModule16,
"linced-admin/adapters/enrolments/log": amdModule17,
"linced-admin/adapters/enrolments/schema": amdModule18,
"linced-admin/adapters/enrolments/unenrolment": amdModule19,
"linced-admin/adapters/goals/base": amdModule20,
"linced-admin/adapters/goals/category": amdModule21,
"linced-admin/adapters/goals/goal": amdModule22,
"linced-admin/adapters/goals/subcategory": amdModule23,
"linced-admin/adapters/goals/subject": amdModule24,
"linced-admin/adapters/group": amdModule25,
"linced-admin/adapters/media": amdModule26,
"linced-admin/adapters/milestones/base": amdModule27,
"linced-admin/adapters/milestones/expectation": amdModule28,
"linced-admin/adapters/milestones/level": amdModule29,
"linced-admin/adapters/milestones/milestone-set": amdModule30,
"linced-admin/adapters/milestones/milestone": amdModule31,
"linced-admin/adapters/milestones/set": amdModule32,
"linced-admin/adapters/people-schema/base": amdModule33,
"linced-admin/adapters/people-schema/field": amdModule34,
"linced-admin/adapters/people-schema/group": amdModule35,
"linced-admin/adapters/people-schema/set": amdModule36,
"linced-admin/adapters/person": amdModule37,
"linced-admin/adapters/posts/base": amdModule38,
"linced-admin/adapters/posts/globalnotice": amdModule39,
"linced-admin/adapters/posts/page": amdModule40,
"linced-admin/adapters/posts/post-template": amdModule41,
"linced-admin/adapters/posts/tag-category": amdModule42,
"linced-admin/adapters/posts/tag": amdModule43,
"linced-admin/adapters/reports/base": amdModule44,
"linced-admin/adapters/reports/rubric-criteria": amdModule45,
"linced-admin/adapters/reports/rubric-element": amdModule46,
"linced-admin/adapters/reports/rubric-family": amdModule47,
"linced-admin/adapters/reports/rubric": amdModule48,
"linced-admin/adapters/school-options/field": amdModule49,
"linced-admin/adapters/school-options/group": amdModule50,
"linced-admin/adapters/school-options/heading": amdModule51,
"linced-admin/adapters/school-options/set": amdModule52,
"linced-admin/adapters/school": amdModule53,
"linced-admin/adapters/schools/base": amdModule54,
"linced-admin/adapters/schools/group": amdModule55,
"linced-admin/adapters/schools/usage-set": amdModule56,
"linced-admin/adapters/sif/au/base": amdModule57,
"linced-admin/adapters/sif/au/zone": amdModule58,
"linced-admin/adapters/timetable/base": amdModule59,
"linced-admin/adapters/timetable/period": amdModule60,
"linced-admin/adapters/timetable/structure": amdModule61,
"linced-admin/adapters/user": amdModule62,
"linced-admin/adapters/wonde/base": amdModule63,
"linced-admin/adapters/wonde/connection": amdModule64,
"linced-admin/adapters/wonde/school": amdModule65,
"linced-admin/config/environment": amdModule66,
"linced-admin/deprecation-workflow": amdModule67,
"linced-admin/enums/auth-sync-status": amdModule68,
"linced-admin/enums/auth-sync-type": amdModule69,
"linced-admin/enums/enrolment-log-resource": amdModule70,
"linced-admin/enums/enrolment-nz-service": amdModule71,
"linced-admin/enums/log-level": amdModule72,
"linced-admin/enums/media-type": amdModule73,
"linced-admin/enums/page-type": amdModule74,
"linced-admin/enums/sif-authentication-method": amdModule75,
"linced-admin/enums/sif-country": amdModule76,
"linced-admin/enums/sif-encoding": amdModule77,
"linced-admin/enums/sif-matrix-param-location": amdModule78,
"linced-admin/mixins/age": amdModule79,
"linced-admin/mixins/edit-assessment": amdModule80,
"linced-admin/models/assessments/assessment": amdModule81,
"linced-admin/models/assessments/category": amdModule82,
"linced-admin/models/assessments/grade-schedule": amdModule83,
"linced-admin/models/assessments/module": amdModule84,
"linced-admin/models/auth/status-sync-error": amdModule85,
"linced-admin/models/auth/status": amdModule86,
"linced-admin/models/client": amdModule87,
"linced-admin/models/cron/log": amdModule88,
"linced-admin/models/cron/task": amdModule89,
"linced-admin/models/enrolments/credential-nz": amdModule90,
"linced-admin/models/enrolments/credential": amdModule91,
"linced-admin/models/enrolments/enrolment": amdModule92,
"linced-admin/models/enrolments/identifier": amdModule93,
"linced-admin/models/enrolments/log": amdModule94,
"linced-admin/models/enrolments/schema": amdModule95,
"linced-admin/models/enrolments/unenrolment": amdModule96,
"linced-admin/models/goals/category": amdModule97,
"linced-admin/models/goals/goal": amdModule98,
"linced-admin/models/goals/state": amdModule99,
"linced-admin/models/goals/subcategory": amdModule100,
"linced-admin/models/goals/subject": amdModule101,
"linced-admin/models/group": amdModule102,
"linced-admin/models/media": amdModule103,
"linced-admin/models/milestones/expectation": amdModule104,
"linced-admin/models/milestones/level": amdModule105,
"linced-admin/models/milestones/milestone-set": amdModule106,
"linced-admin/models/milestones/milestone": amdModule107,
"linced-admin/models/milestones/set": amdModule108,
"linced-admin/models/people-schema/field": amdModule109,
"linced-admin/models/people-schema/group": amdModule110,
"linced-admin/models/people-schema/set": amdModule111,
"linced-admin/models/person": amdModule112,
"linced-admin/models/posts/globalnotice": amdModule113,
"linced-admin/models/posts/page-set": amdModule114,
"linced-admin/models/posts/page": amdModule115,
"linced-admin/models/posts/post-template": amdModule116,
"linced-admin/models/posts/tag-category": amdModule117,
"linced-admin/models/posts/tag": amdModule118,
"linced-admin/models/school-options/field": amdModule119,
"linced-admin/models/school-options/group": amdModule120,
"linced-admin/models/school-options/heading": amdModule121,
"linced-admin/models/school-options/set": amdModule122,
"linced-admin/models/school": amdModule123,
"linced-admin/models/schools/group": amdModule124,
"linced-admin/models/schools/usage-set": amdModule125,
"linced-admin/models/user": amdModule126,
"linced-admin/router": amdModule127,
"linced-admin/serializers/application": amdModule128,
"linced-admin/serializers/assessments/assessment": amdModule129,
"linced-admin/serializers/assessments/base": amdModule130,
"linced-admin/serializers/assessments/category": amdModule131,
"linced-admin/serializers/assessments/grade-schedule": amdModule132,
"linced-admin/serializers/assessments/module": amdModule133,
"linced-admin/serializers/auth/base": amdModule134,
"linced-admin/serializers/auth/status": amdModule135,
"linced-admin/serializers/cron/log": amdModule136,
"linced-admin/serializers/cron/task": amdModule137,
"linced-admin/serializers/enrolments/base": amdModule138,
"linced-admin/serializers/enrolments/credential": amdModule139,
"linced-admin/serializers/enrolments/enrolment": amdModule140,
"linced-admin/serializers/enrolments/identifier": amdModule141,
"linced-admin/serializers/enrolments/log": amdModule142,
"linced-admin/serializers/enrolments/schema": amdModule143,
"linced-admin/serializers/enrolments/unenrolment": amdModule144,
"linced-admin/serializers/goals/base": amdModule145,
"linced-admin/serializers/goals/category": amdModule146,
"linced-admin/serializers/goals/goal": amdModule147,
"linced-admin/serializers/goals/subcategory": amdModule148,
"linced-admin/serializers/goals/subject": amdModule149,
"linced-admin/serializers/group": amdModule150,
"linced-admin/serializers/milestones/base": amdModule151,
"linced-admin/serializers/milestones/expectation": amdModule152,
"linced-admin/serializers/milestones/level": amdModule153,
"linced-admin/serializers/milestones/milestone-set": amdModule154,
"linced-admin/serializers/milestones/milestone": amdModule155,
"linced-admin/serializers/milestones/set": amdModule156,
"linced-admin/serializers/people-schema/base": amdModule157,
"linced-admin/serializers/people-schema/field": amdModule158,
"linced-admin/serializers/people-schema/group": amdModule159,
"linced-admin/serializers/people-schema/set": amdModule160,
"linced-admin/serializers/posts/base": amdModule161,
"linced-admin/serializers/posts/page": amdModule162,
"linced-admin/serializers/posts/post-template": amdModule163,
"linced-admin/serializers/posts/tag-category": amdModule164,
"linced-admin/serializers/posts/tag": amdModule165,
"linced-admin/serializers/reports/rubric-criteria": amdModule166,
"linced-admin/serializers/school-options/field": amdModule167,
"linced-admin/serializers/school-options/group": amdModule168,
"linced-admin/serializers/school-options/heading": amdModule169,
"linced-admin/serializers/school-options/set": amdModule170,
"linced-admin/serializers/school": amdModule171,
"linced-admin/serializers/schools/base": amdModule172,
"linced-admin/serializers/schools/group": amdModule173,
"linced-admin/serializers/schools/usage-set": amdModule174,
"linced-admin/serializers/sif/au/base": amdModule175,
"linced-admin/serializers/sif/au/zone": amdModule176,
"linced-admin/serializers/user": amdModule177,
"linced-admin/services/roles": amdModule178,
"linced-admin/services/school-schema": amdModule179,
"linced-admin/services/store": amdModule180,
"linced-admin/transforms/array-string": amdModule181,
"linced-admin/utils/api-error-detail": amdModule182,
"linced-admin/utils/destroy-record": amdModule183,
"linced-admin/utils/filtering": amdModule184,
"linced-admin/utils/strings": amdModule185,
"linced-admin/initializers/viewport-config": amdModule186,
"linced-admin/services/in-viewport": amdModule187,
"linced-admin/services/-ensure-registered": amdModule188,
"linced-admin/instance-initializers/ember-href-to": amdModule189,
"linced-admin/services/constants": amdModule190,
"linced-admin/services/paper-sidenav": amdModule191,
"linced-admin/services/paper-theme": amdModule192,
"linced-admin/services/paper-toaster": amdModule193,
"linced-admin/services/sniffer": amdModule194,
"linced-admin/utils/clamp": amdModule195,
"linced-admin/transforms/array": amdModule196,
"linced-admin/transforms/fragment-array": amdModule197,
"linced-admin/transforms/fragment": amdModule198,
"linced-admin/initializers/ember-data": amdModule199,
"linced-admin/transforms/date": amdModule200,
"linced-admin/transforms/number": amdModule201,
"linced-admin/transforms/string": amdModule202,
"linced-admin/transforms/boolean": amdModule203,
"linced-admin/data-adapter": amdModule204,
"linced-admin/adapters/base": amdModule205,
"linced-admin/adapters/device": amdModule206,
"linced-admin/adapters/policy": amdModule207,
"linced-admin/initializers/fragment-array-iterable": amdModule208,
"linced-admin/initializers/fragment-array-mutable": amdModule209,
"linced-admin/initializers/oauth2": amdModule210,
"linced-admin/initializers/query-params-helper": amdModule211,
"linced-admin/instance-initializers/faro": amdModule212,
"linced-admin/models/address": amdModule213,
"linced-admin/models/assessments/grade": amdModule214,
"linced-admin/models/assessments/gradeschedule-numeric": amdModule215,
"linced-admin/models/assessments/gradeschedule-range": amdModule216,
"linced-admin/models/assessments/gradeschedule-select": amdModule217,
"linced-admin/models/assessments/gradeschedule-selectvalue": amdModule218,
"linced-admin/models/attendance/nz-moe-day": amdModule219,
"linced-admin/models/auth/qr-code": amdModule220,
"linced-admin/models/autogroup-params": amdModule221,
"linced-admin/models/bookings/allocation": amdModule222,
"linced-admin/models/bookings/booking": amdModule223,
"linced-admin/models/bookings/date": amdModule224,
"linced-admin/models/bookings/event": amdModule225,
"linced-admin/models/bookings/reservation": amdModule226,
"linced-admin/models/bookings/session": amdModule227,
"linced-admin/models/bookings/slot": amdModule228,
"linced-admin/models/bookings/teacher-group-mapping": amdModule229,
"linced-admin/models/cron/process-monitor-error": amdModule230,
"linced-admin/models/cron/process-monitor": amdModule231,
"linced-admin/models/cron/progress": amdModule232,
"linced-admin/models/device": amdModule233,
"linced-admin/models/dynamic-field/value-list-item": amdModule234,
"linced-admin/models/dynamic-field/value": amdModule235,
"linced-admin/models/dynamic-field/values": amdModule236,
"linced-admin/models/enrolments/field": amdModule237,
"linced-admin/models/enrolments/medical-condition": amdModule238,
"linced-admin/models/enrolments/section": amdModule239,
"linced-admin/models/events/cost-mapping-option": amdModule240,
"linced-admin/models/events/cost-mapping": amdModule241,
"linced-admin/models/events/event-count": amdModule242,
"linced-admin/models/events/event": amdModule243,
"linced-admin/models/events/mitigation": amdModule244,
"linced-admin/models/events/option-count": amdModule245,
"linced-admin/models/events/option-limit": amdModule246,
"linced-admin/models/events/permission-reply": amdModule247,
"linced-admin/models/events/permission": amdModule248,
"linced-admin/models/events/risk": amdModule249,
"linced-admin/models/events/template": amdModule250,
"linced-admin/models/events/value-limit": amdModule251,
"linced-admin/models/finance/account": amdModule252,
"linced-admin/models/finance/line-item": amdModule253,
"linced-admin/models/goals/badge-assertion": amdModule254,
"linced-admin/models/goals/badge-badge": amdModule255,
"linced-admin/models/goals/badge-criteria": amdModule256,
"linced-admin/models/goals/badge-profile": amdModule257,
"linced-admin/models/goals/badge-recipient": amdModule258,
"linced-admin/models/goals/badge-verification": amdModule259,
"linced-admin/models/goals/badge": amdModule260,
"linced-admin/models/groups/member": amdModule261,
"linced-admin/models/media/image": amdModule262,
"linced-admin/models/media/rendition": amdModule263,
"linced-admin/models/media/video": amdModule264,
"linced-admin/models/milestones/progression": amdModule265,
"linced-admin/models/notifications/notification": amdModule266,
"linced-admin/models/people-schema/field-option": amdModule267,
"linced-admin/models/people/caregiver": amdModule268,
"linced-admin/models/people/learner": amdModule269,
"linced-admin/models/people/medical": amdModule270,
"linced-admin/models/people/options": amdModule271,
"linced-admin/models/people/policy-acceptance": amdModule272,
"linced-admin/models/people/post-count-assessment": amdModule273,
"linced-admin/models/people/post-count-base": amdModule274,
"linced-admin/models/people/post-count-goal": amdModule275,
"linced-admin/models/people/post-count-page": amdModule276,
"linced-admin/models/people/post-counts": amdModule277,
"linced-admin/models/people/staff": amdModule278,
"linced-admin/models/policy": amdModule279,
"linced-admin/models/posts/attendancenote": amdModule280,
"linced-admin/models/posts/comment": amdModule281,
"linced-admin/models/posts/feed-entry": amdModule282,
"linced-admin/models/posts/member": amdModule283,
"linced-admin/models/posts/post": amdModule284,
"linced-admin/models/posts/reaction": amdModule285,
"linced-admin/models/reports/report-feedback": amdModule286,
"linced-admin/models/reports/report-judgement-wording": amdModule287,
"linced-admin/models/reports/report-template-period": amdModule288,
"linced-admin/models/reports/report-template-section": amdModule289,
"linced-admin/models/reports/report-template": amdModule290,
"linced-admin/models/reports/rubric-column": amdModule291,
"linced-admin/models/reports/rubric-criteria": amdModule292,
"linced-admin/models/reports/rubric-element": amdModule293,
"linced-admin/models/reports/rubric-family": amdModule294,
"linced-admin/models/reports/rubric-state": amdModule295,
"linced-admin/models/reports/rubric": amdModule296,
"linced-admin/models/reports/student-report-section-element": amdModule297,
"linced-admin/models/reports/student-report-section": amdModule298,
"linced-admin/models/reports/student-report": amdModule299,
"linced-admin/models/schools/location": amdModule300,
"linced-admin/models/sif/au/connection": amdModule301,
"linced-admin/models/sif/au/zone": amdModule302,
"linced-admin/models/snapshots/pdf-include": amdModule303,
"linced-admin/models/snapshots/pdf": amdModule304,
"linced-admin/models/snapshots/snapshot-set": amdModule305,
"linced-admin/models/snapshots/snapshot": amdModule306,
"linced-admin/models/surveys/response": amdModule307,
"linced-admin/models/surveys/survey": amdModule308,
"linced-admin/models/term": amdModule309,
"linced-admin/models/timeframe": amdModule310,
"linced-admin/models/timetable/day": amdModule311,
"linced-admin/models/timetable/period": amdModule312,
"linced-admin/models/timetable/structure": amdModule313,
"linced-admin/models/wonde/address": amdModule314,
"linced-admin/models/wonde/connection": amdModule315,
"linced-admin/models/wonde/school": amdModule316,
"linced-admin/serializers/address": amdModule317,
"linced-admin/serializers/auth/qr-code": amdModule318,
"linced-admin/serializers/bookings/allocation": amdModule319,
"linced-admin/serializers/bookings/base": amdModule320,
"linced-admin/serializers/bookings/booking": amdModule321,
"linced-admin/serializers/bookings/event": amdModule322,
"linced-admin/serializers/bookings/slot": amdModule323,
"linced-admin/serializers/cron/process-monitor": amdModule324,
"linced-admin/serializers/dynamic-field/value": amdModule325,
"linced-admin/serializers/events/base": amdModule326,
"linced-admin/serializers/events/cost-mapping-option": amdModule327,
"linced-admin/serializers/events/cost-mapping": amdModule328,
"linced-admin/serializers/events/event-count": amdModule329,
"linced-admin/serializers/events/event": amdModule330,
"linced-admin/serializers/events/mitigation": amdModule331,
"linced-admin/serializers/events/permission-reply": amdModule332,
"linced-admin/serializers/events/permission": amdModule333,
"linced-admin/serializers/events/risk": amdModule334,
"linced-admin/serializers/events/template": amdModule335,
"linced-admin/serializers/goals/badge": amdModule336,
"linced-admin/serializers/goals/state": amdModule337,
"linced-admin/serializers/media": amdModule338,
"linced-admin/serializers/milestones/progression": amdModule339,
"linced-admin/serializers/person": amdModule340,
"linced-admin/serializers/posts/attendancenote": amdModule341,
"linced-admin/serializers/posts/comment": amdModule342,
"linced-admin/serializers/posts/feed-entry": amdModule343,
"linced-admin/serializers/posts/globalnotice": amdModule344,
"linced-admin/serializers/posts/page-set": amdModule345,
"linced-admin/serializers/posts/post": amdModule346,
"linced-admin/serializers/posts/reaction": amdModule347,
"linced-admin/serializers/reports/base": amdModule348,
"linced-admin/serializers/reports/report-feedback": amdModule349,
"linced-admin/serializers/reports/report-template-section": amdModule350,
"linced-admin/serializers/reports/report-template": amdModule351,
"linced-admin/serializers/reports/rubric-element": amdModule352,
"linced-admin/serializers/reports/rubric-family": amdModule353,
"linced-admin/serializers/reports/rubric-state": amdModule354,
"linced-admin/serializers/reports/rubric": amdModule355,
"linced-admin/serializers/reports/student-report-section": amdModule356,
"linced-admin/serializers/reports/student-report": amdModule357,
"linced-admin/serializers/sif/au/connection": amdModule358,
"linced-admin/serializers/surveys/base": amdModule359,
"linced-admin/serializers/surveys/response": amdModule360,
"linced-admin/serializers/surveys/survey": amdModule361,
"linced-admin/serializers/timetable/base": amdModule362,
"linced-admin/serializers/timetable/period": amdModule363,
"linced-admin/serializers/timetable/structure": amdModule364,
"linced-admin/serializers/wonde/connection": amdModule365,
"linced-admin/serializers/wonde/school": amdModule366,
"linced-admin/services/colours": amdModule367,
"linced-admin/services/dates": amdModule368,
"linced-admin/services/environment": amdModule369,
"linced-admin/services/faro": amdModule370,
"linced-admin/services/fetch": amdModule371,
"linced-admin/services/field-options": amdModule372,
"linced-admin/services/google-drive": amdModule373,
"linced-admin/services/group-years": amdModule374,
"linced-admin/services/hero-api-auth": amdModule375,
"linced-admin/services/hero-api-bookings-allocations": amdModule376,
"linced-admin/services/hero-api-bookings": amdModule377,
"linced-admin/services/hero-api-comments": amdModule378,
"linced-admin/services/hero-api-goals": amdModule379,
"linced-admin/services/hero-api-people": amdModule380,
"linced-admin/services/hero-api": amdModule381,
"linced-admin/services/logging": amdModule382,
"linced-admin/services/media": amdModule383,
"linced-admin/services/notifications": amdModule384,
"linced-admin/services/options": amdModule385,
"linced-admin/services/permissions": amdModule386,
"linced-admin/services/person-options": amdModule387,
"linced-admin/services/policy-acceptance": amdModule388,
"linced-admin/services/print": amdModule389,
"linced-admin/services/push-notifications": amdModule390,
"linced-admin/services/session": amdModule391,
"linced-admin/services/strings": amdModule392,
"linced-admin/services/tax": amdModule393,
"linced-admin/services/terms": amdModule394,
"linced-admin/services/toaster": amdModule395,
"linced-admin/services/uppy": amdModule396,
"linced-admin/transforms/json": amdModule397,
"linced-admin/utils/auditing": amdModule398,
"linced-admin/utils/chunk": amdModule399,
"linced-admin/utils/colour": amdModule400,
"linced-admin/utils/d3-tip": amdModule401,
"linced-admin/utils/dynamic-field-types": amdModule402,
"linced-admin/utils/fields": amdModule403,
"linced-admin/utils/grades": amdModule404,
"linced-admin/utils/long-tasks": amdModule405,
"linced-admin/utils/map-with-concurrency": amdModule406,
"linced-admin/utils/oauth2": amdModule407,
"linced-admin/utils/options": amdModule408,
"linced-admin/utils/platform": amdModule409,
"linced-admin/utils/post-templates": amdModule410,
"linced-admin/utils/progressions": amdModule411,
"linced-admin/utils/pronouns": amdModule412,
"linced-admin/utils/reports": amdModule413,
"linced-admin/utils/school-date": amdModule414,
"linced-admin/utils/snapshots": amdModule415,
"linced-admin/utils/stationery": amdModule416,
"linced-admin/utils/table": amdModule417,
"linced-admin/utils/tags": amdModule418,
"linced-admin/utils/tinymce": amdModule419,
"linced-admin/utils/topic-steps": amdModule420,
"linced-admin/services/page-title": amdModule421,
"linced-admin/services/drag-sort": amdModule422,
"linced-admin/templates/application": amdModule423,
"linced-admin/controllers/application": amdModule424,
"linced-admin/routes/application": amdModule425,
"linced-admin/templates/assessments": amdModule426,
"linced-admin/controllers/assessments": amdModule427,
"linced-admin/routes/assessments": amdModule428,
"linced-admin/templates/assessments/assessment": amdModule429,
"linced-admin/controllers/assessments/assessment": amdModule430,
"linced-admin/routes/assessments/assessment": amdModule431,
"linced-admin/templates/assessments/grade-schedules": amdModule432,
"linced-admin/controllers/assessments/grade-schedules": amdModule433,
"linced-admin/routes/assessments/grade-schedules": amdModule434,
"linced-admin/templates/assessments/index": amdModule435,
"linced-admin/controllers/assessments/index": amdModule436,
"linced-admin/routes/assessments/index": amdModule437,
"linced-admin/templates/auth/clients": amdModule438,
"linced-admin/controllers/auth/clients": amdModule439,
"linced-admin/routes/auth/clients": amdModule440,
"linced-admin/templates/auth/fusionauth": amdModule441,
"linced-admin/controllers/auth/fusionauth": amdModule442,
"linced-admin/templates/autogroups": amdModule443,
"linced-admin/controllers/autogroups": amdModule444,
"linced-admin/routes/autogroups": amdModule445,
"linced-admin/templates/contacts/search": amdModule446,
"linced-admin/controllers/contacts/search": amdModule447,
"linced-admin/routes/contacts/search": amdModule448,
"linced-admin/templates/cron/index": amdModule449,
"linced-admin/controllers/cron/index": amdModule450,
"linced-admin/routes/cron/index": amdModule451,
"linced-admin/templates/cron/task": amdModule452,
"linced-admin/controllers/cron/task": amdModule453,
"linced-admin/routes/cron/task": amdModule454,
"linced-admin/templates/enrolment/schema/template": amdModule455,
"linced-admin/controllers/enrolment/schema/template": amdModule456,
"linced-admin/routes/enrolment/schema/template": amdModule457,
"linced-admin/templates/enrolment/schema/templates": amdModule458,
"linced-admin/controllers/enrolment/schema/templates": amdModule459,
"linced-admin/routes/enrolment/schema/templates": amdModule460,
"linced-admin/templates/error": amdModule461,
"linced-admin/controllers/error": amdModule462,
"linced-admin/templates/finance/nsw-sap/transaction-upload": amdModule463,
"linced-admin/controllers/finance/nsw-sap/transaction-upload": amdModule464,
"linced-admin/routes/finance/nsw-sap/transaction-upload": amdModule465,
"linced-admin/templates/finance/nz-report": amdModule466,
"linced-admin/controllers/finance/nz-report": amdModule467,
"linced-admin/routes/finance/nz-report": amdModule468,
"linced-admin/templates/finance/schema-update": amdModule469,
"linced-admin/controllers/finance/schema-update": amdModule470,
"linced-admin/routes/finance/schema-update": amdModule471,
"linced-admin/templates/goals": amdModule472,
"linced-admin/routes/goals": amdModule473,
"linced-admin/templates/goals/index": amdModule474,
"linced-admin/controllers/goals/index": amdModule475,
"linced-admin/routes/goals/index": amdModule476,
"linced-admin/templates/goals/plp": amdModule477,
"linced-admin/controllers/goals/plp": amdModule478,
"linced-admin/routes/goals/plp": amdModule479,
"linced-admin/templates/goals/subject": amdModule480,
"linced-admin/controllers/goals/subject": amdModule481,
"linced-admin/routes/goals/subject": amdModule482,
"linced-admin/templates/hero-notices": amdModule483,
"linced-admin/routes/hero-notices": amdModule484,
"linced-admin/templates/hero-notices/index": amdModule485,
"linced-admin/controllers/hero-notices/index": amdModule486,
"linced-admin/routes/hero-notices/index": amdModule487,
"linced-admin/templates/hero-notices/notice": amdModule488,
"linced-admin/controllers/hero-notices/notice": amdModule489,
"linced-admin/routes/hero-notices/notice": amdModule490,
"linced-admin/templates/home": amdModule491,
"linced-admin/controllers/home": amdModule492,
"linced-admin/routes/home": amdModule493,
"linced-admin/controllers/index": amdModule494,
"linced-admin/routes/index": amdModule495,
"linced-admin/templates/logs/enrolments": amdModule496,
"linced-admin/controllers/logs/enrolments": amdModule497,
"linced-admin/routes/logs/enrolments": amdModule498,
"linced-admin/templates/milestones/set": amdModule499,
"linced-admin/controllers/milestones/set": amdModule500,
"linced-admin/routes/milestones/set": amdModule501,
"linced-admin/templates/milestones/sets": amdModule502,
"linced-admin/controllers/milestones/sets": amdModule503,
"linced-admin/routes/milestones/sets": amdModule504,
"linced-admin/templates/my-profile": amdModule505,
"linced-admin/controllers/my-profile": amdModule506,
"linced-admin/routes/my-profile": amdModule507,
"linced-admin/templates/page-templates": amdModule508,
"linced-admin/controllers/page-templates": amdModule509,
"linced-admin/routes/page-templates": amdModule510,
"linced-admin/templates/people": amdModule511,
"linced-admin/routes/people": amdModule512,
"linced-admin/templates/people/schema/apply-templates": amdModule513,
"linced-admin/controllers/people/schema/apply-templates": amdModule514,
"linced-admin/routes/people/schema/apply-templates": amdModule515,
"linced-admin/templates/people/schema/resequence-groups": amdModule516,
"linced-admin/controllers/people/schema/resequence-groups": amdModule517,
"linced-admin/routes/people/schema/resequence-groups": amdModule518,
"linced-admin/templates/people/schema/template": amdModule519,
"linced-admin/routes/people/schema/template": amdModule520,
"linced-admin/templates/people/schema/template/group": amdModule521,
"linced-admin/controllers/people/schema/template/group": amdModule522,
"linced-admin/routes/people/schema/template/group": amdModule523,
"linced-admin/templates/people/schema/template/groups": amdModule524,
"linced-admin/controllers/people/schema/template/groups": amdModule525,
"linced-admin/routes/people/schema/template/groups": amdModule526,
"linced-admin/templates/people/schema/template/view": amdModule527,
"linced-admin/controllers/people/schema/template/view": amdModule528,
"linced-admin/routes/people/schema/template/view": amdModule529,
"linced-admin/templates/people/schema/templates": amdModule530,
"linced-admin/controllers/people/schema/templates": amdModule531,
"linced-admin/routes/people/schema/templates": amdModule532,
"linced-admin/templates/people/information": amdModule533,
"linced-admin/routes/people/information": amdModule534,
"linced-admin/templates/post-templates": amdModule535,
"linced-admin/controllers/post-templates": amdModule536,
"linced-admin/routes/post-templates": amdModule537,
"linced-admin/templates/rubrics": amdModule538,
"linced-admin/controllers/rubrics": amdModule539,
"linced-admin/routes/rubrics": amdModule540,
"linced-admin/templates/rubrics/index": amdModule541,
"linced-admin/controllers/rubrics/index": amdModule542,
"linced-admin/routes/rubrics/index": amdModule543,
"linced-admin/templates/rubrics/rubric": amdModule544,
"linced-admin/controllers/rubrics/rubric": amdModule545,
"linced-admin/routes/rubrics/rubric": amdModule546,
"linced-admin/templates/school-groups": amdModule547,
"linced-admin/controllers/school-groups": amdModule548,
"linced-admin/routes/school-groups": amdModule549,
"linced-admin/templates/school-options/fields": amdModule550,
"linced-admin/controllers/school-options/fields": amdModule551,
"linced-admin/routes/school-options/fields": amdModule552,
"linced-admin/templates/school-options/groups": amdModule553,
"linced-admin/controllers/school-options/groups": amdModule554,
"linced-admin/routes/school-options/groups": amdModule555,
"linced-admin/templates/school-options/headings": amdModule556,
"linced-admin/controllers/school-options/headings": amdModule557,
"linced-admin/routes/school-options/headings": amdModule558,
"linced-admin/templates/school-options/preview": amdModule559,
"linced-admin/controllers/school-options/preview": amdModule560,
"linced-admin/routes/school-options/preview": amdModule561,
"linced-admin/templates/school-options/sets": amdModule562,
"linced-admin/controllers/school-options/sets": amdModule563,
"linced-admin/routes/school-options/sets": amdModule564,
"linced-admin/templates/schools": amdModule565,
"linced-admin/controllers/schools": amdModule566,
"linced-admin/routes/schools": amdModule567,
"linced-admin/templates/sif/zones": amdModule568,
"linced-admin/controllers/sif/zones": amdModule569,
"linced-admin/routes/sif/zones": amdModule570,
"linced-admin/templates/tags": amdModule571,
"linced-admin/controllers/tags": amdModule572,
"linced-admin/routes/tags": amdModule573,
"linced-admin/templates/tags/category": amdModule574,
"linced-admin/controllers/tags/category": amdModule575,
"linced-admin/routes/tags/category": amdModule576,
"linced-admin/templates/tags/index": amdModule577,
"linced-admin/controllers/tags/index": amdModule578,
"linced-admin/routes/tags/index": amdModule579,
"linced-admin/templates/usage-sets": amdModule580,
"linced-admin/routes/usage-sets": amdModule581,
"linced-admin/templates/usage-sets/index": amdModule582,
"linced-admin/controllers/usage-sets/index": amdModule583,
"linced-admin/routes/usage-sets/index": amdModule584,
"linced-admin/templates/usage-sets/usage-set": amdModule585,
"linced-admin/controllers/usage-sets/usage-set": amdModule586,
"linced-admin/routes/usage-sets/usage-set": amdModule587,
"linced-admin/templates/users": amdModule588,
"linced-admin/controllers/users": amdModule589,
"linced-admin/routes/users": amdModule590,
"linced-admin/templates/wonde/connections": amdModule591,
"linced-admin/controllers/wonde/connections": amdModule592,
"linced-admin/routes/wonde/connections": amdModule593,
"linced-admin/templates/access-denied": amdModule594,
"linced-admin/templates/loading": amdModule595,
"linced-admin/templates/logged-out": amdModule596,
"linced-admin/controllers/logged-out": amdModule597,
"linced-admin/routes/logged-out": amdModule598,
"linced-admin/templates/login-failed": amdModule599,
"linced-admin/controllers/login-failed": amdModule600,
"linced-admin/routes/login-failed": amdModule601,
"linced-admin/templates/school-switching": amdModule602,
"linced-admin/controllers/school-switching": amdModule603,
"linced-admin/routes/school-switching": amdModule604,
"linced-admin/templates/callback": amdModule605,
"linced-admin/routes/callback": amdModule606,
"linced-admin/routes/login": amdModule607,
"linced-admin/templates/logout": amdModule608,
"linced-admin/routes/logout": amdModule609,
"linced-admin/routes/springboard": amdModule610,
"linced-admin/routes/startup": amdModule611,
"linced-admin/templates/not-found": amdModule612,
  },
  exportFastbootModules
);
